import { SECURITY_CONTEXT_PATHS } from '@/utils/crossOriginIsolated'
import createLogger from '@/utils/logger'
import type { NavigationGuardNext, RouteLocationNormalizedGeneric } from 'vue-router'

const logger = createLogger('router/guards/crossOriginIsolated.ts')

function checkSecurityContext(nextPath: string) {
  if (import.meta.env.VITE_DISABLED_SECURITY_CONTEXT === 'true') {
    return
  }
  const isSecurityRoute = SECURITY_CONTEXT_PATHS.some((path) => nextPath.startsWith(path))
  const isIsolated = window.crossOriginIsolated // Returns true if COOP/COEP are active

  // Scenario A: Entering the route without isolation
  if (isSecurityRoute && !isIsolated) {
    logger.log('Entering high-security route. Forcing reload to apply COOP/COEP headers.')
    window.location.href = nextPath
  }

  // Scenario B: Leaving the route (Optional)
  // You might want to reload to "unlock" the browser context so 3rd party
  // scripts (like Google Auth) work again on other pages.
  if (!isSecurityRoute && isIsolated) {
    logger.log('Leaving high-security route. Resetting browser context.')
    window.location.href = nextPath
  }
}

export async function crossOriginIsolated(
  to: RouteLocationNormalizedGeneric,
  _from: RouteLocationNormalizedGeneric,
  next: NavigationGuardNext,
) {
  checkSecurityContext(to.path)
  next()
}
